import { render, staticRenderFns } from "./ClinicNoReturn.vue?vue&type=template&id=2f05e745"
import script from "./ClinicNoReturn.vue?vue&type=script&lang=js"
export * from "./ClinicNoReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports